<template>
  <div>
    <!-- mobile -->
    <div
      v-if="isMobile"
      class="banner-mobile"
      :style="{ width, height: heightComputed, borderRadius }"
    >
      <swiper
        ref="mobileSwiper"
        :options="swiperOptions"
        :style="{ borderRadius }"
      >
        <swiper-slide v-for="item in list" :key="item[srcKey]">
          <a class="img-wrap" @click="toPage(item,$event)">
            <img class="img-wrap-banner" :src="item[srcKey]" />
          </a>
        </swiper-slide>
      </swiper>
      <ul class="pagination">
        <li
          v-for="(item, index) in list"
          :key="item[srcKey]"
          :class="{ active: index === active }"
        ></li>
      </ul>
    </div>
    <!-- web -->
    <div v-else class="custom-swiper">
      <el-carousel
        ref="banner"
        class="banner-web"
        :interval="interval"
        :height="heightComputed"
        :style="{ width, height: heightComputed, borderRadius }"
        trigger="click"
        arrow="never"
        :indicator-position="list.length > 1 ? '' : 'none'"
      >
        <el-carousel-item v-for="item in list" :key="item[srcKey]">
          <a
            class="img-wrap"
            :style="{ backgroundImage: `url(${item[srcKey]})` }"
            @click="toPage(item,$event)"
          >
          </a>
        </el-carousel-item>
      </el-carousel>
      <template v-if="list.length > 1">
        <div class="custom-arrow custom-arrow-left" @click="arrowClick('prev')">
          <fps-icon type="arrow-left" size="24" />
        </div>
        <div
          class="custom-arrow custom-arrow-right"
          @click="arrowClick('next')"
        >
          <fps-icon type="arrow-right" size="24" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
// import 'swiper/swiper-bundle.css';
import 'swiper/css/swiper.min.css';

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    const _this = this;
    return {
      isMobile: window.innerWidth < 600,
      active: 0,
      swiperOptions: {
        loop: true,
        speed: 1000,
        on: {
          slideChangeTransitionEnd: function() {
            console.log(this);
            _this.active = this.realIndex;
          }
        }
      },
      $swiper: null
    };
  },
  props: {
    width: {
      type: [String, Number],
      default() {
        return '100%';
      }
    },
    height: {
      type: [String, Number],
      default() {
        return '100%';
      }
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    srcKey: {
      type: String,
      default: 'imageUrl'
    },
    linkKey: {
      type: String,
      default: 'jumpUrl'
    },
    borderRadius: {
      type: [String, Number],
      default: 0
    },
    interval: {
      type: Number,
      default: 0
    }
  },
  computed: {
    heightComputed() {
      const { height } = this;
      if (!height) return '100%';
      return typeof height == 'number' ? height + 'px' : height;
    }
  },
  mounted() {
    if (this.isMobile) {
      this.$swiper = this.$refs.mobileSwiper.$swiper;
      if (!this.$swiper) return;
      this.$nextTick(() => {
        this.$swiper.slideNext();
        this.active = 0;
        this.bannerSlide();
      });
    }
  },
  methods: {
      toPage(item,e) {
      if (!item[this.linkKey]) {
        e.preventDefault();
      } else {
        window.open(item[this.linkKey], this.getTarget(item));
      }
    },
    sleep(duration) {
      return new Promise(resolve => {
        setTimeout(resolve, duration);
      });
    },
    async bannerSlide() {
      const { $swiper, interval } = this;
      const moving = async duration => {
        await this.sleep(duration);
        $swiper.slideNext();
      };
      // eslint-disable-next-line no-constant-condition
      while (true) {
        await moving(interval);
      }
    },
    arrowClick(method) {
      let $swipe = this.$refs.banner;
      if (!$swipe) return;
      if (!$swipe[method]) return;
      $swipe[method]();
    },
    getTarget(item) {
      const link = item[this.linkKey];
      if (link) {
        if (link.indexOf('/') === 0 || link.indexOf('nicee.tw') !== -1) {
          return '_self';
        } else {
          return '_blank';
        }
      }
      return '_self';
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-web {
  position: relative;
  overflow: hidden;
  z-index: 0;
}

.banner-mobile {
  position: relative;
  & > * {
    width: 100%;
    height: 100%;
  }
  .pagination {
    @include flex;
    position: absolute;
    z-index: 10;
    left: 0;
    bottom: 12px;
    width: 100%;
    height: 4px;
    li {
      display: block;
      width: 4px;
      height: 4px;
      border-radius: 2px;
      background-color: rgba($color: #fff, $alpha: 0.5);
      margin: 0 1px;
      &.active {
        width: 8px;
        background-color: #fff;
      }
    }
  }
}
@media screen and (max-width: 599px) {
  .img-wrap-banner {
    margin-top: 20px;
    max-width: 100%;
  }
}
.img-wrap {
  @include flex;
  width: 100%;
  height: 100%;
  background-position: center center;
  background-size: cover;
}
</style>
